export interface JsonLayerChart {
  listNum: number;
  symbol: string;
  chartCode: number;
  comments: string;
  annotations: string;
  description: string;
  style: string;
  recID: number;
}

export function isJsonLayerChart(unknownValue: unknown): unknownValue is JsonLayerChart {
  return (
    typeof unknownValue === 'object' &&
    unknownValue !== null &&
    'listNum' in unknownValue &&
    'symbol' in unknownValue &&
    'chartCode' in unknownValue &&
    'comments' in unknownValue &&
    'annotations' in unknownValue &&
    'description' in unknownValue &&
    'style' in unknownValue &&
    'recID' in unknownValue &&
    typeof unknownValue.listNum === 'number' &&
    typeof unknownValue.symbol === 'string' &&
    typeof unknownValue.chartCode === 'number' &&
    typeof unknownValue.comments === 'string' &&
    typeof unknownValue.annotations === 'string' &&
    typeof unknownValue.description === 'string' &&
    typeof unknownValue.style === 'string' &&
    typeof unknownValue.recID === 'number'
  );
}
